export default __webpack_public_path__ + "media/flags/tt-a27db96a.svg";